import React from 'react';
import { Modal } from '@routific/hive/v5';
import { useTranslation } from 'react-i18next';
import UnpublishConfirmBody from './molecules/UnpublishConfirmBody';
import UnpublishConfirmFooter from './molecules/UnpublishConfirmFooter';

interface Props {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}

const UnpublishConfirmModal: React.FC<Props> = ({
  visible, onOk, onCancel,
}) => {
  const { t } = useTranslation('components');

  return (
    <Modal
      size="sm"
      open={visible}
      title={t('unpublishRouteConfirmModal.title', { count: 1 })}
      onClose={onCancel}
      footer={<UnpublishConfirmFooter onOk={onOk} onCancel={onCancel} />}
      data-cy="unpublish-confirm-modal"
    >
      <UnpublishConfirmBody />
    </Modal>
  );
};

export default UnpublishConfirmModal;
